"use client";
import {CSSProperties, JSX, ReactNode} from "react";

import Link from "next/link";

import SmartImage from "@/shared/ui/smart-image";

import {PolymorphicButton} from "./types";

import "./styles/button-with-image.scss";

type ButtonWithImageProps = {
    icon?: string;
    alt?: string;
    width?: number;
    height?: number;
    variant?: "primary" | "default";
    iconColor?: string;
    children?: ReactNode;
    prefetch?: boolean;
};

type ButtonWithImagePolymorphic = PolymorphicButton<ButtonWithImageProps>;

export function ButtonWithImage(props: ButtonWithImagePolymorphic): JSX.Element {
    const {icon, alt = "", width = 24, height = 24, variant = "default", iconColor, children, className: userClassName, ...rest} = props;

    const className = `button-with-image button-with-image--${variant}${userClassName ? ` ${userClassName}` : ""}`;
    const style = iconColor ? ({"--icon-color": iconColor} as CSSProperties) : undefined;

    const iconElement = children ? (
        <span className="button-with-image__icon">{children}</span>
    ) : icon ? (
        <SmartImage src={icon} width={width} height={height} alt={alt} className="button-with-image__icon" />
    ) : null;

    if (rest.as === "link") {
        const {as: _as, target, href, prefetch = false, ...linkProps} = rest;
        return (
            <Link href={href || "/"} className={className} style={style} prefetch={prefetch} {...(target && {target})} {...linkProps}>
                {iconElement}
            </Link>
        );
    }

    const {as: _as, type = "button", ...buttonProps} = rest;
    return (
        <button type={type} className={className} style={style} {...buttonProps}>
            {iconElement}
        </button>
    );
}
